import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

type Props = ButtonProps & {
  loading?: boolean
}

const GButton: React.FC<Props> = ({
  loading,
  children,
  ...rest
}) => (
  <Button disabled={loading} {...rest}>
    {
      loading
        ? <CircularProgress color="inherit" size={16} />
        : children
    }
  </Button>
);

export default GButton;
